import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds
} from "../../Ads";
import { SERVER_URL } from "./ConstantsHealthCalculator";
import { FoodEnergy_EndPoint } from "./ConstantsHealthCalculator";
import SharedHelmet from "../Helmet";
const TITLE = "حساب التحويل من السعرات الحرارية الى الجول والكيلوجول ";
const DESCRIPTION =
  "هل ترغب في تحويل السعرات الحرارية إلى وحدات قياس أخرى مثل الجول والكيلوجول؟ استخدم هذه الحاسبة لتحصل على القيم المحددة بسهولة وسرعة  ";
const KEYWORDS =
  "تحويل السعرات الحرارية إلى الجول, تحويل السعرات الحرارية إلى الكيلوجول, كيفية تحويل السعرات الحرارية إلى الجول, كيفية تحويل السعرات الحرارية إلى الكيلوجول, جدول تحويل السعرات الحرارية إلى الجول والكيلوجول, السعرات الحرارية والجول والكيلوجول: التحويل والمعادلات, حاسبة تحويل السعرات الحرارية إلى الجول والكيلوجول, التحويل من وحدة السعرات الحرارية إلى وحدة الجول, التحويل من وحدة السعرات الحرارية إلى وحدة الكيلوجول, كيفية عمل التحويل بين السعرات الحرارية والجول والكيلوجول";
const OG_URL = "https://do-calculate.com/calculator/ar/foodenergy/";
const apiEndpoint = `${SERVER_URL}/${FoodEnergy_EndPoint}`;
function FoodEnergyCalculator() {
  const [value, setValue] = useState(1);
  const [unitFrom, setUnitFrom] = useState("kcal");
  const [unitTo, setUnitTo] = useState("kcal");
  const [newValue, setNewValue] = useState(1);
  const [result, setRestul] = useState(null);
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleValueChange = (event) => {
    setValue(event.target.value);
  };
  const handleUnitFromChange = (event) => {
    setUnitFrom(event.target.value);
  };
  const handleUnitToChange = (event) => {
    setUnitTo(event.target.value);
  };
  const handleNewValueChange = (event) => {
    setNewValue(event.target.value);
  };
  const calculateFoodEnergy = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ value, unitFrom }),
      });
      const data = await response.json();
      setStatusCode(response.status);
      if (response.ok) {
        setRestul(data.result);
        if (unitTo === "kcal") {
          setNewValue(data.result.kcal);
        } else if (unitTo === "cal") {
          setNewValue(data.result.cal);
        } else if (unitTo === "J") {
          setNewValue(data.result.J);
        } else if (unitTo === "kJ") {
          setNewValue(data.result.kJ);
        }
        setError(null);
      } else {
        setRestul(null);
        setError(data.error);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                تقوم حاسبة التحويل من السعرات الحرارية الى الجول والكيلوجول
                بحساب قيمة تحويل الطاقة بين وحدات مختلفة. تستلم الدالة قيمة
                ووحدة كمدخلات وتقوم بتحويل القيمة إلى قيم طاقة مكافئة في وحدات
                أخرى. الوحدات المدعومة للتحويل تشمل kcal (السعرة الحرارية)، cal
                (السعرة الحرارية الصغيرة)، kJ (الكيلوجول)، و J (الجول).
                <br />
                بإمكانك استخدام هذه الدالة لتحويل قيمة الطاقة بين الوحدات
                المذكورة والحصول على القيم المكافئة في الوحدات الأخرى.
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة تحويل طاقة الغذاء
                </div>
                <hr />

                {/* FROM row */}
                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3">
                  <input
                    type="number"
                    id="weightNumberFrom"
                    value={value}
                    onChange={handleValueChange}
                    className="form-control"
                    placeholder="175"
                    style={{ width: "90%" }}
                  />
                  <label
                    htmlFor="unitFrom"
                    className="mb-0 fw-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    وحدة
                  </label>
                  <select
                    id="unitFrom"
                    className="form-select"
                    style={{ width: "90%" }}
                    value={unitFrom}
                    onChange={handleUnitFromChange}
                  >
                    <option value="kcal">Calorie (kcal)</option>
                    <option value="cal">calorie (cal)</option>
                    <option value="kJ">Kilojoules (kJ)</option>
                    <option value="J">joules (J)</option>
                  </select>
                </div>

                {/* = sign */}
                <div className="text-center fw-bold fs-4 mb-3">=</div>

                {/* TO row */}
                <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mb-3">
                  <input
                    type="number"
                    id="weightNumberTo"
                    value={newValue}
                    onChange={handleNewValueChange}
                    className="form-control"
                    placeholder="0"
                    style={{ width: "90%" }}
                    readOnly
                  />
                  <label
                    htmlFor="unitTo"
                    className="mb-0 fw-bold"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    وحدة
                  </label>
                  <select
                    id="unitTo"
                    className="form-select"
                    style={{ width: "90%" }}
                    value={unitTo}
                    onChange={handleUnitToChange}
                  >
                    <option value="kcal">Calorie (kcal)</option>
                    <option value="cal">calorie (cal)</option>
                    <option value="J">joules (J)</option>
                    <option value="kJ">Kilojoules (kJ)</option>
                  </select>
                </div>

                <hr />
                <div className="text-center">
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateFoodEnergy}
                  >
                    احسب
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {statusCode === 400 && (
                  <div className="alert alert-warning">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>
                    يُرجى إدخال جميع الحقول بالشكل الصحيح.
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                تحويل السعرات الحرارية إلى الجول والكيلوجول: الطرق والجداول
                والحسابات:
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    مقالة: السعرات الحرارية وكيفية حسابها لتحقيق التغذية السليمة
                  </h2>
                </u>
                <br />
                <p>
                  تُستخدم السعرات الحرارية كوحدة قياس للطاقة في مجال التغذية
                  وعلم التغذية. ومع ذلك، هناك أحيانًا حاجة لتحويل هذه السعرات
                  الحرارية إلى وحدات أخرى مثل الجول والكيلوجول. في هذه المقالة،
                  سنتناول كيفية تحويل السعرات الحرارية إلى الجول والكيلوجول
                  وسنقدم جدول تحويل لمساعدتك في القيام بذلك.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    ما هي السعرات الحرارية والجول والكيلوجول؟
                  </h2>
                </u>
                <ul>
                  <li>
                    السعرات الحرارية (Calories): هي وحدة قياس الطاقة الشائعة في
                    مجال التغذية. تُستخدم لقياس كمية الطاقة المستهلكة أو
                    المحتواة في الطعام والمشروبات. تُرمز إلى السعرات الحرارية
                    بالاختصار "كال".
                  </li>
                  <li>
                    الجول (Joule): هي وحدة دولية لقياس الطاقة. تُستخدم على نطاق
                    واسع في العلوم والهندسة. 1 جول يعادل تقريبا 0.239 سعرة
                    حرارية.
                  </li>
                  <li>
                    الكيلوجول (Kilojoule): هي وحدة قياس للطاقة تُستخدم أيضًا على
                    نطاق واسع. 1 كيلوجول يعادل 239 سعرة حرارية.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    كيفية تحويل السعرات الحرارية إلى الجول:
                  </h2>
                </u>
                <br />
                <p>
                  لتحويل السعرات الحرارية إلى الجول، يمكنك استخدام العلاقة
                  التالية: 1 سعرة حرارية (Calorie) = 4.184 جول (Joule) ببساطة،
                  يُضرب عدد السعرات الحرارية في 4.184 للحصول على الجول. على سبيل
                  المثال، إذا كانت الوجبة تحتوي على 100 سعرة حرارية، فإنها
                  تُعادل 418.4 جول.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    كيفية تحويل السعرات الحرارية إلى الكيلوجول:
                  </h2>
                </u>
                <br />
                <p>
                  لتحويل السعرات الحرارية إلى الكيلوجول، يمكنك استخدام العلاقة
                  التالية: 1 سعرة حرارية (Calorie) = 0.004184 كيلوجول
                  (Kilojoule) ببساطة، يُقسم عدد السعرات الحرارية على 239 للحصول
                  على الكيلوجول. على سبيل المثال، إذا كانت الوجبة تحتوي على 100
                  سعرة حرارية، فإنها تُعادل 0.4184 كيلوجول.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    جدول تحويل السعرات الحرارية إلى الجول والكيلوجول:
                  </h2>
                </u>
                <br />
                لسهولة الاستخدام، إليك جدول يوضح تحويل السعرات الحرارية إلى
                الجول والكيلوجول:
                <table >
                  <thead>
                    <tr>
                      <th >
                        السعرات الحرارية (Calories)
                      </th>
                      <th >الجول (Joule)</th>
                      <th >الكيلوجول (Kilojoule)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>4.184</td>
                      <td>0.004184</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td>41.84</td>
                      <td>0.04184</td>
                    </tr>
                    <tr>
                      <td>50</td>
                      <td>209.2</td>
                      <td>0.2092</td>
                    </tr>
                    <tr>
                      <td>100</td>
                      <td>418.4</td>
                      <td>0.4184</td>
                    </tr>
                    <tr>
                      <td>500</td>
                      <td>2092</td>
                      <td>2.092</td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>

                    كيف تعمل هذه الحاسبة بحساب قيم الطاقة بين وحدات مختلفة:
                  </h2>
                </u>
                <br />
                <p>
                  هذه الحاسبة تقوم بتحويل قيم الطاقة بين وحدات مختلفة. ببساطة،
                  يمكنك استخدام هذه الحاسبة لتحويل قيمة الطاقة من وحدة إلى أخرى.
                </p>
                <p>
                  عند استخدامك لهذه الحاسبة، عليك تزويدها بقيمة الطاقة التي ترغب
                  في تحويلها، وكذلك وحدة القياس الأصلية. ثم، ستقوم الحاسبة
                  بتحويل هذه القيمة إلى الوحدات الأخرى المتاحة وإعطاءك القيم
                  المكافئة لها. باستخدام هذه الحاسبة، يمكنك تسهيل عملية تحويل
                  قيم الطاقة بسهولة ودقة، حتى لو لم تكن متخصصًا في هذا المجال.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default FoodEnergyCalculator;
